'use strict'

import Helper from '@/utils/helper'

class AbstractService {
  _processError (error) {
    // eslint-disable-next-line no-empty
    if (Helper.isNull(error.axios)) {}
  }
}

export default AbstractService
